// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CoverageSegment } from './coverageSegment';

export type CoverageAnalysisSegments = CoverageSegment[] | null;
